import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Provider } from 'mobx-react';
import { RecoilRoot } from 'recoil';
import { ToastContainer } from 'react-toastify';
import { StyledEngineProvider } from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

import AppContainer from './containers';

import { stores } from './stores';
import AppStore from './stores/AppStore';

if (!window.__APP_STORE__) {
  window.__APP_STORE__ = new AppStore();
}
const appStore = window.__APP_STORE__;

if (!window.__ALL_STORES__) {
  window.__ALL_STORES__ = {
    store: appStore,
    ...stores,
    permissionStore: appStore.permissionStore,
  };
}
const allStores = window.__ALL_STORES__;

function App() {
  useEffect(() => {
    appStore.permissionStore.getAclSettings();
  }, []);

  return (
    <StyledEngineProvider injectFirst>
      <RecoilRoot>
        <Provider {...allStores}>
          <ToastContainer closeOnClick draggable />
          <Router>
            <Routes>
              <Route path="/*" element={<AppContainer />} />
            </Routes>
          </Router>
        </Provider>
      </RecoilRoot>
    </StyledEngineProvider>
  );
}

export default App;
